import i18n from '@/i18n';

export const getTranslatedError = (
	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
	error: NonNullable<any>,
	fallback = 'errors.genericError'
) => {
	const code = error?.response?.data?.code;

	if (!code) {
		return i18n.global.t(fallback);
	}
	const key = `error.${code}`;
	const translationError = i18n.global.t(key);
	return translationError === key ? i18n.global.t(fallback) : translationError;
};

// biome-ignore lint/suspicious/noExplicitAny: Init Biome
export const formatErrors = (errors: any, to?: string, fullErr?: any) => {
	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
	const formatedErrors: any = { errors: {}, _global: [] };

	if (errors && Array.isArray(errors)) {
		// biome-ignore lint/suspicious/noExplicitAny: Init Biome
		errors.forEach((err: any) => {
			if (err.id) {
				if (err.id === 'Validation.EmailIsAlreadyUsed') {
					err.context = 'email';
				}
				if (typeof err.context === 'string') {
					if (err.context.indexOf('body.') !== -1) {
						err.context = err.context.replace('body.', '');
					}
					formatedErrors.errors[err.context] = {};
					formatedErrors.errors[err.context].id = err.id;
					formatedErrors.errors[err.context].action = to || '';
					formatedErrors.errors[err.context].key = err.context;
					formatedErrors.errors[err.context].data = err.data;
				} else {
					formatedErrors._global.push({
						id: err.id,
						action: to,
						data: err.data,
					});
				}
			}
		});
	}

	return {
		errors: formatedErrors.errors || {},
		_global: formatedErrors._global || [],
		fullErr,
	};
};

const BUSINESS_ERROR_KEYS: Record<string, string> = {
	'WORKER.MAIN_CV_NOT_PARSED': 'page.profile.career.error.cvNotParsed',
	'WORKER.MAIN_CV_PARSING_EMPTY': 'error.cvParsing.noText',
	'WORKER.MAIN_CV_PARSING_FAILED': 'error.cvParsing.failed',
	'WORKER.NOT_LINKED_TO_AGENCY':
		'page.worker.askedChanges.message.notLinkedToAgency',
};

export const getApiErrorMessage = (
	// biome-ignore lint/suspicious/noExplicitAny: matches getTranslatedError
	error: any,
	fallback = 'toast.defaultError'
): string => {
	const code = error?.response?.data?.code;

	if (typeof code === 'string') {
		const businessKey = BUSINESS_ERROR_KEYS[code];
		if (businessKey) {
			return i18n.global.t(businessKey);
		}
		const key = `error.${code}`;
		const translated = i18n.global.t(key);
		if (translated !== key) {
			return translated;
		}
	}

	if (typeof code === 'string' && code.includes('.')) {
		const message = error?.response?.data?.message;
		if (typeof message === 'string' && message.trim()) {
			return message.trim();
		}
	}

	return i18n.global.t(fallback);
};
